// isFinite,
var isNil = function (value) {
    /**
     * isNil(null) => true
     * isNil() => true
     */
    return value === null || value === undefined;
};
export default isNil;
//# sourceMappingURL=is-nil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-nil.js
// module id = 43
// module chunks = 3